import { CapturedPiecesContainer } from "./CapturedPiecesContainer";
import { GameVars } from "../../GameVars";
import { GameConstants } from "../../GameConstants";
import { GameManager } from "../../GameManager";
import { AudioManager } from "../../AudioManager";

export class PlayerCapsule extends Phaser.Group {

    public capturedPieces: CapturedPiecesContainer;
    public color: string;
    public isPlayer: boolean;
    public plusButton: Phaser.Button;

    private playerNameLabel: Phaser.Text;
    private pulsing: boolean;
    private framesCounter: number;
    private minusButton: Phaser.Button; 
    private currentPlayerMark: Phaser.Image;
    
    constructor(game: Phaser.Game, isPlayer: boolean) {

        super(game, null, "player-capsule");

        this.isPlayer = isPlayer;
        this.pulsing = false;
        this.framesCounter = 0;

        if (this.isPlayer) {
            this.color = GameVars.colorPlayer;
            this.y = GameConstants.GAME_HEIGHT;
        } else {
            
            this.color = GameVars.colorPlayer === GameConstants.WHITE ? GameConstants.BLACK : GameConstants.WHITE;
            this.y = 93 * GameVars.scaleY; // la altura de la barra del tab superior descontando la sombra

            const capsuleBackground: Phaser.Sprite = new Phaser.Sprite(this.game, 0, 0, this.game.cache.getBitmapData(GameConstants.BLACK_SQUARE));
            capsuleBackground.scale.set(GameConstants.GAME_WIDTH / 64, 82 / 64);
            capsuleBackground.alpha = .35;
            this.add(capsuleBackground);
        }

        this.scale.y = GameVars.scaleY;

        this.capturedPieces = new CapturedPiecesContainer(this.game, this.isPlayer, this);
        this.add(this.capturedPieces);

        this.configureTab();

        this.currentPlayerMark = new Phaser.Image(this.game, 0, 0, "texture_atlas_1", "current_player.png");
        this.add(this.currentPlayerMark);

        if (this.isPlayer) {
            this.currentPlayerMark.y = 10;
            this.currentPlayerMark.anchor.y = 1;
        } else {
            this.currentPlayerMark.y = -10;
        }

        this.currentPlayerMark.visible = false;

        if (this.isPlayer) {

            if (!GameVars.playerCapturedPiecesVisible) {
                this.onClickMinus(null, null, null, true);
            }

        } else {

            if (!GameVars.adversaryCapturedPiecesVisible) {
                this.onClickMinus(null, null, null, true);
            }
        }

        this.alpha = 0;

        this.game.add.tween(this)
            .to({alpha: 1}, 350, Phaser.Easing.Cubic.Out, true);
    }

    public update(): void {

        if (this.pulsing) {
            
            this.framesCounter++;

            let alpha: number;

            if (this.framesCounter < 30) {
                alpha = 1 - .5 * this.framesCounter / 30;
            } else {
                alpha = .5 + .5 * (this.framesCounter - 30) / 30;
                if (this.framesCounter === 60) {
                    this.framesCounter = 0;
                }
            }

            this.currentPlayerMark.alpha = alpha;
        }
    }

    public startPulsing(): void {

        this.currentPlayerMark.visible = true;

        this.pulsing = true;
        this.framesCounter = 0;
    }

    public stopPulsing(): void {

            this.currentPlayerMark.visible = false;

        this.pulsing = false;
        this.playerNameLabel.alpha = 1;
    }

    private configureTab(): void {
        
        let tabImage: Phaser.Image;
        let avatarImage: Phaser.Image;
        let playerNameLabelColor: string;

        if (this.isPlayer) {

            this.minusButton = new Phaser.Button(this.game, GameConstants.GAME_WIDTH - 50, 0, "texture_atlas_1", this.onClickMinus, this);
            this.minusButton.anchor.set(1, 1);
            this.minusButton.scale.x = -1;

            this.plusButton = new Phaser.Button(this.game, 230 - 60, 0, "texture_atlas_1", this.onClickPlus, this);
            this.plusButton.anchor.y = 1;

            if (GameVars.colorPlayer === GameConstants.WHITE) {

                tabImage = new Phaser.Image(this.game, 82, 0, "texture_atlas_1", "white_tab.png");  
                playerNameLabelColor = GameConstants.TEXT_COLOR_BLACK; 

                this.minusButton.setFrames("tab_minus_white_on.png", "tab_minus_white_off.png", "tab_minus_white_on.png");
                this.plusButton.setFrames("tab_plus_white_on.png", "tab_plus_white_off.png", "tab_plus_white_on.png");
    
            } else {

                tabImage = new Phaser.Image(this.game, 82, 0, "texture_atlas_1", "black_tab.png");
                playerNameLabelColor = GameConstants.TEXT_COLOR_WHITE;

                this.minusButton.setFrames("tab_minus_black_on.png", "tab_minus_black_off.png", "tab_minus_black_on.png");
                this.plusButton.setFrames("tab_plus_black_on.png", "tab_plus_black_off.png", "tab_plus_black_on.png");
            }

            tabImage.anchor.y = 1;

            if (GameVars.avatarsLoaded) {
                avatarImage = new Phaser.Image(this.game, 41, -41, "player-avatar");
            } else {
                avatarImage = new Phaser.Image(this.game, 41, -41, "texture_atlas_1", "default-avatar.png");
            }

            let playerName = "PLAYER";
            
            this.playerNameLabel = new Phaser.Text(this.game, 96, -54, GameVars.texts[GameVars.language][playerName], { font: "22px Roboto Slab Regular", fill: playerNameLabelColor, align: "center"}); 

            } else {

            this.minusButton = new Phaser.Button(this.game, 0, 0, "texture_atlas_1", this.onClickMinus, this);
            
            this.plusButton = new Phaser.Button(this.game, 538 + 60, 0, "texture_atlas_1", this.onClickPlus, this);
            this.plusButton.scale.x = -1;

            if (GameVars.colorPlayer === GameConstants.WHITE) {

                tabImage = new Phaser.Image(this.game, 0, -13, "texture_atlas_1", "black_tab.png");  
                playerNameLabelColor = GameConstants.TEXT_COLOR_WHITE;  

                this.minusButton.setFrames("tab_minus_black_on.png", "tab_minus_black_off.png", "tab_minus_black_on.png");
                this.plusButton.setFrames("tab_plus_black_on.png", "tab_plus_black_off.png", "tab_plus_black_on.png");
        
            } else {

                tabImage = new Phaser.Image(this.game, 0, -13, "texture_atlas_1", "white_tab.png");
                playerNameLabelColor = GameConstants.TEXT_COLOR_BLACK; 

                this.minusButton.setFrames("tab_minus_white_on.png", "tab_minus_white_off.png", "tab_minus_white_on.png");
                this.plusButton.setFrames("tab_plus_white_on.png", "tab_plus_white_off.png", "tab_plus_white_on.png");
            }

            tabImage.scale.x = -1;
            tabImage.x = GameConstants.GAME_WIDTH - 82;

            let adversaryName: string;

            if (GameVars.againstAI) {
                adversaryName = "COMPUTER";
                avatarImage = new Phaser.Image(this.game, 726, 41, "texture_atlas_1", "avatar-computer.png");
            }

            this.playerNameLabel = new Phaser.Text(this.game, 670, 28, GameVars.texts[GameVars.language][adversaryName], { font: "22px Roboto Slab Regular", fill: playerNameLabelColor, align: "center"}); 
            this.playerNameLabel.anchor.x = 1;
        }

        this.plusButton.visible = false;
        this.add(this.plusButton);

        this.add(tabImage);

        avatarImage.scale.set(82 / avatarImage.width);
        avatarImage.anchor.set(.5);
        this.add(avatarImage);

        this.add(this.playerNameLabel);

        this.add(this.minusButton);            
    }

    private onClickMinus(b: Phaser.Button, p: Phaser.Pointer, c: boolean, noTween?: any): void {

        this.capturedPieces.hide(noTween);
        
        let final_minus_px: number;
        let final_plus_px: number;

        if (this.isPlayer) {
            final_minus_px = GameConstants.GAME_WIDTH;
            final_plus_px = 230;
        } else {
            final_minus_px = -50;
            final_plus_px = 538;
        }
        
        this.plusButton.visible = true;
        
        if (noTween) {

            this.minusButton.visible = false;
            this.minusButton.x = final_minus_px;

            this.plusButton.x = final_plus_px;

        } else {

            this.game.add.tween(this.minusButton)
                .to({x: final_minus_px}, 350, Phaser.Easing.Cubic.Out, true)
                .onComplete.add(function(): void {
                    this.minusButton.visible = false;
                }, this);

            this.game.add.tween(this.plusButton)
                .to({x: final_plus_px}, 350, Phaser.Easing.Cubic.Out, true);
        }

        GameManager.capturedPiecesVisibilityChanged(this.isPlayer, false);

        AudioManager.playSound("click"); 
    }

    private onClickPlus(): void {

        this.capturedPieces.show();
        
        let final_minus_px: number;
        let final_plus_px: number;

        if (this.isPlayer) {
            final_minus_px = GameConstants.GAME_WIDTH - 50;
            final_plus_px = 238 - 60;
        } else {
            final_minus_px = 0;
            final_plus_px = 532 + 60;
        }

        this.minusButton.visible = true;
        this.game.add.tween(this.minusButton)
            .to({x: final_minus_px}, 350, Phaser.Easing.Cubic.Out, true);

        this.game.add.tween(this.plusButton)
            .to({x: final_plus_px}, 350, Phaser.Easing.Cubic.Out, true)
            .onComplete.add(function(): void {
                this.plusButton.visible = false;
            }, this);

        GameManager.capturedPiecesVisibilityChanged(this.isPlayer, true);

        AudioManager.playSound("click"); 
    }
}
